import type { CSS } from '../../stitches.config';

export type DirectionTypes = 'column' | 'column-reverse' | 'row' | 'row-reverse';
export type DirectionProps = { direction?: DirectionTypes };

export const directionCSS = (direction?: DirectionTypes): CSS =>
  direction != null
    ? {
        flexDirection: direction,
      }
    : {};
